import { useQuery } from '@apollo/client';
import { usePersonId } from 'src/components/providers/PersonIdProvider';
import { PERSON_QUERY } from '../queries/person';
const usePerson = options => {
  const personReferenceId = usePersonId();
  const {
    data,
    ...rest
  } = useQuery(PERSON_QUERY, {
    ...options,
    variables: {
      personReferenceId,
      ...options.variables
    },
    skip: options.skip || !personReferenceId
  });
  return {
    data: data?.person,
    ...rest
  };
};
export default usePerson;